import {Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React, {memo} from 'react'

import {Drawer} from '../../../../components/Drawer'
import * as classes from './AddressDrawer.classes'

type AddressDrawerProps = React.PropsWithChildren<{
  isFinalRoutePoint: boolean
  onClose: VoidFunction
  onSubmit: VoidFunction
  opened: boolean
  title?: string
}>

export const AddressDrawer = memo(
  ({children, isFinalRoutePoint, onClose, onSubmit, opened, title}: AddressDrawerProps): React.ReactElement => {
    const i18n = useI18n()

    return (
      <Drawer onClose={onClose} opened={opened} title={title} fullScreen>
        <Drawer.Body>{children}</Drawer.Body>
        <Drawer.FixedButton flexDirection="column" justifyContent="center" onPress={onSubmit}>
          <Typography thickness="medium" variant="body2">
            {i18n('bdui.address.submit_button.title')}
          </Typography>
          {!isFinalRoutePoint && (
            <Typography className={classes.captionText} variant="caption1">
              {i18n('bdui.address.submit_button.to_recipient')}
            </Typography>
          )}
        </Drawer.FixedButton>
      </Drawer>
    )
  },
)
